import { SORT_BY } from 'Pods/SearchPage/Store/constants'

// Figma 590:28155 order.
const SORT_LABEL_KEYS = [
  [SORT_BY.BEST_MATCH, 'best_match'],
  [SORT_BY.TOP_SELLING, 'top_sellers'],
  [SORT_BY.NEWEST, 'newest'],
  [SORT_BY.LOWEST_PRICE, 'lower_price'],
  [SORT_BY.HIGHEST_PRICE, 'higher_price'],
  [SORT_BY.TRENDING, 'trending'],
]

// Oldest is no longer offered, but legacy `sort_by=oldest` links still hydrate it and the backend
// still applies it, so it is listed only while active to keep the applied sort visible.
const RETIRED_SORT_LABEL_KEYS = [
  [SORT_BY.OLDEST, 'oldest'],
]

// Built per render rather than at module scope: the labels are locale-dependent and the i18next
// singleton never leaves lng 'en', so they must be resolved through the page's useTranslate.
export const buildSortingFiltersConfig = (translate, activeSort) => [{
  label: null,
  filters: [
    ...SORT_LABEL_KEYS,
    ...RETIRED_SORT_LABEL_KEYS.filter(([value]) => value === activeSort),
  ].map(([value, key]) => ({
    value,
    label: translate(`search_page.filters.sorting.${key}`),
  })),
}]
